import { Component, OnInit, Input } from '@angular/core';
import { Degree } from 'src/app/shared/models/user';
import { BehaviorSubject } from 'rxjs';
import { MobileUiService } from 'src/app/shared/services/mobile-ui.service';

@Component({
  selector: 'app-profile-degree',
  templateUrl: './profile-degree.component.html',
  styleUrls: ['./profile-degree.component.scss']
})
export class ProfileDegreeComponent implements OnInit {
  @Input() degrees = new BehaviorSubject<Degree[]>([]);
  degreeHeadElements = ['Degree', 'Discipline', 'Year', 'Institution'];
  isMobile = new BehaviorSubject<boolean>(false);

  constructor(private mobileUiService: MobileUiService) {
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
  }

}
